//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import angular from 'angular';

angular.module('curalate').directive('recordClickEvent', [
  'TrackingService',
  (TrackingService) => ({
    restrict: 'A',
    link(scope, element, attrs) {
      element.on('click', () => {
        if (!attrs.disabled) {
          const {
                        recordClickEventCategory,
                        recordClickEventAction,
                        recordClickEventLabel,
                        recordClickEventValue,
                    } = attrs;

          TrackingService.recordEvent(
                        recordClickEventCategory,
                        recordClickEventAction,
                        recordClickEventLabel,
                        recordClickEventValue,
                    );
        }
      });
    },
  })]);
